(() => {
  'use strict';
  if (window.MiniamiHomeOffers) {
    window.MiniamiHomeOffers.init(document);
    return;
  }
  const parse = (raw, commerce = window.MiniamiParallelCommerce) => {
    try {
      const data = typeof raw === 'string' ? JSON.parse(raw) : raw;
      const config = commerce?.parseAovConfig(data);
      const offers = typeof data.offers === 'string' ? JSON.parse(data.offers) : data.offers;
      const offer = Array.isArray(offers) && offers.find(entry => entry.id === config?.offerId
        && entry.type === 'bundle-builder' && entry.status === 'active' && entry.enabledDiscount === true
        && entry.bundleBuilderProductId === `gid://shopify/Product/${data.productId}`
        && entry.bundleBuilderId === `gid://shopify/ProductVariant/${data.variantId}`);
      if (!config || !offer || !Object.keys(config.eligible).length || config.tiers.length !== 5) return null;
      const tiers = [...config.tiers].sort((a, b) => a.min - b.min);
      if (tiers.some((tier, index) => tier.min !== index + 2 || tier.pct <= 0 || tier.pct > 100
        || (index > 0 && tier.pct < tiers[index - 1].pct))) return null;
      return { ...config, tiers, maxPercent: Math.max(...tiers.map(tier => tier.pct)) };
    } catch { return null; }
  };
  const show = (node, visible) => {
    if (!node) return;
    node.hidden = !visible;
    node.classList.toggle('hidden', !visible);
  };
  const init = scope => {
    const scripts = [...scope.querySelectorAll('[data-home-aov-config]')];
    if (scope.matches?.('[data-home-aov-config]')) scripts.unshift(scope);
    scripts.forEach(script => {
      const root = script.closest('[data-home-aov-target]');
      if (!root) return;
      const config = parse(script.textContent);
      const pill = root.querySelector('[data-home-aov-pill]');
      const bundleIdentity = pill?.dataset.bundleIdentity === 'fixed_bundle' || pill?.dataset.bundleIdentity === 'bundle_builder';
      show(pill, bundleIdentity || Boolean(config));
      root.dataset.homeAovReady = String(Boolean(config));
      if (root.dataset.homeAovTarget === 'shelf') {
        if (pill && (bundleIdentity || config)) {
          pill.querySelector('[data-home-aov-pill-text]').textContent = bundleIdentity ? 'Bundle' : 'SALE';
          pill.dataset.bundleSaleState = bundleIdentity ? 'native-product-role' : 'native-aov-active-offer';
        }
        return;
      }
      root.dataset.commerceVerdict = config ? 'native-aov-active-offer' : 'platform-config-blocked';
      const body = root.querySelector('[data-home-aov-description]');
      if (body) body.textContent = config ? body.dataset.offerCopy : 'Pick any patterns you like.';
      const engine = root.querySelector('[data-pickmix-engine]');
      if (engine) engine.dataset.pickmixDiscountEnabled = String(Boolean(config));
      if (config && pill) pill.querySelector('[data-home-aov-pill-text]').textContent = `UP TO ${config.maxPercent}% OFF`;
      [...root.querySelectorAll('[data-pickmix-status-line]')].slice(1).forEach((line, index) => {
        const count = index + 1;
        const tier = config?.tiers.find(entry => entry.min === count);
        line.textContent = `${count} picked${config ? (count === 1 ? ' · add one more to save' : ` · save ${tier.pct}%`) : ''}`;
      });
    });
  };
  window.MiniamiHomeOffers = Object.freeze({ parse, init });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
